import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { AlertModule } from '../alert/alert.module';
import { HeaderService } from './header.service';

@NgModule({
  imports: [
    CommonModule,
    AlertModule
  ],
  declarations: [HeaderComponent],
  exports: [
    HeaderComponent
  ],
  providers: [HeaderService]
})
export class HeaderModule { }
